export default __webpack_public_path__ + "static/media/linkedin.83fc9225.svg";